export default{
  administrators: (state) => state.administrators
}



// WEBPACK FOOTER //
// ./src/components/admin/store/getters.js